import React from "react";

const PrivacyPolicy = () => {
  return (
    <>
      <section
        style={{
          paddingTop: "108px",
          background: "linear-gradient(135deg, #1f3c88 0%, #39a0ed 100%)",
        }}
      >
        <div className="auto-container">
          <div style={{ padding: "42px 0 36px", textAlign: "center", color: "#ffffff" }}>
            <h1 style={{ fontSize: "40px", fontWeight: 700, marginBottom: "8px", color: "#ffffff" }}>
              Privacy Policy - Asysta
            </h1>
          </div>
        </div>
      </section>

      <section
        style={{
          background: "linear-gradient(180deg, #eef4ff 0%, #ffffff 100%)",
          padding: "42px 0 80px",
        }}
      >
        <div className="auto-container">
          <div
            style={{
              maxWidth: "980px",
              margin: "0 auto",
              background: "#ffffff",
              borderRadius: "14px",
              boxShadow: "0 12px 30px rgba(15, 39, 73, 0.10)",
              border: "1px solid #e4ebf7",
              padding: "38px 32px",
              color: "#2a2a2a",
              lineHeight: "1.75",
            }}
          >
            <p style={{ marginBottom: "14px", color: "#5c6675", fontWeight: 600 }}>Last Updated: [28/05/2026]</p>

            <p>
              This Privacy Policy describes how Asysta ("we", "our", "us") collects, uses, stores, and protects your
              information when you access or use{" "}
              <a href="https://www.asysta.in" target="_blank" rel="noreferrer">
                www.asysta.in
              </a>{" "}
              ("Website") and our related services ("Services").
            </p>
            <p>By using our Website, you agree to the practices described in this Privacy Policy.</p>

            <p><strong>1. Information We Collect</strong><br />
              We collect the following types of information:
            </p>

            <p><strong>1.1 Personal Information (Provided by You)</strong><br />
              When you create an account, book a course, or contact us, we may collect:<br />
              Full name<br />
              Email address<br />
              Phone number<br />
              Address or location details<br />
              Account login details<br />
              Booking information<br />
              Payment-related information (handled by third-party gateways)
            </p>

            <p><strong>1.2 Automatically Collected Information</strong><br />
              When you visit our Website, we may automatically collect:<br />
              IP address<br />
              Device type<br />
              Browser type<br />
              Operating system<br />
              Pages visited<br />
              Time spent on pages<br />
              Cookies and similar tracking technologies
            </p>

            <p><strong>1.3 Location Data</strong><br />
              To provide accurate driving school recommendations, we may collect:<br />
              GPS-based location (with your permission)<br />
              IP-based location<br />
              User-submitted location (city, area, PIN code)
            </p>

            <p><strong>1.4 Third-Party Information</strong><br />
              Driving schools may share limited information with us, such as:<br />
              Booking confirmations<br />
              Training status<br />
              Instructor availability<br />
              Course completion updates
            </p>

            <p><strong>2. How We Use Your Information</strong><br />
              We use your information to:<br />
              Create and manage your account<br />
              Process bookings and payments<br />
              Recommend nearby driving schools<br />
              Provide customer support<br />
              Improve our Website and Services<br />
              Send notifications, updates, or alerts<br />
              Conduct analytics and performance monitoring<br />
              Prevent fraud and enhance security<br />
              We do not sell your personal information.
            </p>

            <p><strong>3. Payments &amp; Financial Information</strong><br />
              Payments made on Asysta are processed by third-party payment gateways.<br />
              We do not store:<br />
              Card numbers<br />
              CVV<br />
              Net banking passwords<br />
              UPI PINs<br />
              Payment gateways follow their own security and privacy policies.
            </p>

            <p><strong>4. Sharing of Information</strong><br />
              We may share your information with:
            </p>

            <p><strong>4.1 Driving Schools (Service Providers)</strong><br />
              To complete your booking, we may share:<br />
              Name<br />
              Phone number<br />
              Location<br />
              Course preferences<br />
              Driving schools use this information solely to deliver training services.
            </p>

            <p><strong>4.2 Third-Party Service Providers</strong><br />
              We may share data with:<br />
              Payment gateways<br />
              Analytics tools<br />
              Hosting providers<br />
              Communication tools (e.g., WhatsApp APIs)<br />
              Customer support tools<br />
              All partners are required to protect your data.
            </p>

            <p><strong>4.3 Legal Requirements</strong><br />
              We may disclose information if required by:<br />
              Law enforcement<br />
              Government authorities<br />
              Court orders<br />
              Applicable Indian laws
            </p>

            <p><strong>5. Cookies &amp; Tracking Technologies</strong><br />
              We use cookies to:<br />
              Improve website functionality<br />
              Remember user preferences<br />
              Analyze traffic and usage patterns<br />
              Provide personalized recommendations<br />
              You may disable cookies in your browser settings, but some features may not work properly.
            </p>

            <p><strong>6. Data Security</strong><br />
              We use reasonable technical and organizational measures to protect your data.<br />
              However, no method of transmission over the internet is 100% secure. You use the Website at your own risk.
            </p>

            <p><strong>7. Your Rights (India-Specific)</strong><br />
              You may request to:<br />
              Access your personal data<br />
              Update or correct your data<br />
              Delete your data (subject to legal requirements)<br />
              Withdraw consent<br />
              Opt out of marketing communications<br />
              To exercise these rights, contact us at [Info@asysta.in].
            </p>

            <p><strong>8. Children's Privacy</strong><br />
              Our Services are not intended for children under 13. We do not knowingly collect information from minors.<br />
              If you believe a child has provided data, contact us to remove it.
            </p>

            <p><strong>9. Third-Party Links</strong><br />
              Our Website may contain links to external websites. We are not responsible for their content, policies, or practices.
            </p>

            <p><strong>10. Data Retention</strong><br />
              We retain your information for as long as necessary to:<br />
              Provide our Services<br />
              Comply with legal obligations<br />
              Resolve disputes<br />
              Enforce agreements
            </p>

            <p><strong>11. Changes to This Privacy Policy</strong><br />
              We may update this Privacy Policy at any time. Changes will be posted on this page with an updated "Last Updated" date.<br />
              Continued use of the Website means you accept the updated policy.
            </p>

            <p><strong>12. Contact Us</strong><br />
              If you have questions about this Privacy Policy, contact us at:<br />
              <i className="fas fa-envelope" aria-hidden="true" style={{ marginRight: "6px" }}></i>
              <a href="mailto:info@asysta.in">info@asysta.in</a>
              <span style={{ display: "inline-block", width: "14px" }}></span>
              <i className="fas fa-globe" aria-hidden="true" style={{ marginRight: "6px" }}></i>
              <a href="https://www.asysta.in" target="_blank" rel="noreferrer">www.asysta.in</a>
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default PrivacyPolicy;
